import { DetailsListLayoutMode, IColumn, Selection, Link, IDragDropContext, IDragDropEvents, IListProps, SelectionMode, Text, CommandBar, ICommandBarItemProps, IButtonProps, IPersonaSharedProps, Persona, PersonaSize, getTheme, SearchBox, Stack, Callout, DirectionalHint, IconButton, TagPicker, IBasePickerSuggestionsProps, IInputProps, ITag, TagItemSuggestion, FontIcon, TagItem, ISuggestionsProps, ISuggestionItemProps, ISuggestionModel, TextField, ITextFieldProps, Label, Overlay, ComboBox, Dropdown, PrimaryButton, DefaultButton, SpinButton, IContextualMenuProps, ShimmeredDetailsList, FocusZone, FocusZoneTabbableElements, FontWeights, Spinner, SpinnerSize, memoizeFunction, CommandBarButton, IDropdownOption, IStackComponent, ISearchBoxProps, IPeoplePickerItemSelectedProps, PeoplePickerItem, ValidationState, NormalPeoplePicker, IPersonaProps, IPickerItemProps, TooltipHost, DialogFooter, CheckboxVisibility, ConstrainMode, StackItem } from "@fluentui/react"
import { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useAppDispatch } from "../../../../../app/Hooks"
import { APIResponse, ApiMessage, ORGANIZATION_LOGO_URL, TRADING_API_URL, getHeaders } from "../../../../../app/Api"
import { currencyFormatter, formatDate, printComponent, normalizeKey, timestampToDate } from "../../../../../app/Helpers"
import { TableState } from "../../../../common/Table/TableSate"
import { useNavigate, useSearchParams } from "react-router-dom"
import { PageProps } from "../../../PageProps"
import {
    widget,
    ChartingLibraryWidgetOptions,
    LanguageCode,
    ResolutionString,
    ChartingLibraryFeatureset,
    IBasicDataFeed,
    CustomTimezoneId,
    TimezoneId,
} from '../../../../../charting_library';
import * as React from 'react';
import { getCurrentLanguage } from '../../../../../app/Helpers';
import { useAppSelector } from '../../../../../app/Hooks';
import { useParams } from 'react-router-dom';
import { setTitle } from "../../../../common/NavHeader/NavHeaderSlice"
import { getPage } from "../../../../../app/Pages"
import { setPage } from "../../../../layouts/Master/MasterLayoutSlice"
import { Int32Value, StringValue } from "google-protobuf/google/protobuf/wrappers_pb"
import { Timestamp } from "google-protobuf/google/protobuf/timestamp_pb"
import moment from "moment"
import { dismissMessage, getTreasury, getItems, reset } from "./TreasuryChartSlice"
import { CurrencyForm } from "../../../../../app/Enums"
import { SessionExpiredDialog } from "../../../../common/SessionExpiredDialog/SessionExpiredDialog"
import { Message } from "../../../../common/Message/Message"
import { LocalStorageSaveLoadAdapter } from "../../../../../app/TVStorage"
import { GetStatementRequest } from "../../../../../repository/Accountant/account_operation_pb"
import { GetTreasuryBalanceReportResponse, GetTreasuryBalanceReportRequest } from "../../../../../repository/Accountant/report_pb"
import { GetTreasuryRequest } from "../../../../../repository/Accountant/treasury_pb"

export interface ChartContainerProps {
    symbol: ChartingLibraryWidgetOptions['symbol'];
    interval: ChartingLibraryWidgetOptions['interval'];

    // BEWARE: no trailing slash is expected in feed URL
    datafeedUrl: string;
    libraryPath: ChartingLibraryWidgetOptions['library_path'];
    chartsStorageUrl: ChartingLibraryWidgetOptions['charts_storage_url'];
    chartsStorageApiVersion: ChartingLibraryWidgetOptions['charts_storage_api_version'];
    clientId: ChartingLibraryWidgetOptions['client_id'];
    userId: ChartingLibraryWidgetOptions['user_id'];
    fullscreen: ChartingLibraryWidgetOptions['fullscreen'];
    autosize: ChartingLibraryWidgetOptions['autosize'];
    studiesOverrides: ChartingLibraryWidgetOptions['studies_overrides'];
    container: ChartingLibraryWidgetOptions['container'];
}
let org: number = -1;

var lastTime: any = undefined;
var currentReselution: any = undefined;
var myInterval: any = undefined;

let req: GetTreasuryBalanceReportRequest;
let reqAcc: GetTreasuryRequest;
let getItemsPromise: any;
let getFilterPromise: any;
let actionPromise: any;

const key = "treasuriesManagement/treasuries/chart"
export const TreasuryChartPage: React.FunctionComponent<PageProps> = (props) => {

    const dispatch = useAppDispatch()
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const chartContainerRef = useRef<HTMLDivElement>(null);
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const disabled_features: ChartingLibraryFeatureset[] = []
    const disabled_features_mobile: ChartingLibraryFeatureset[] = [
        'use_localstorage_for_settings',
        'left_toolbar', 'header_widget', 'timeframes_toolbar', 'edit_buttons_in_legend', 'context_menus', 'control_bar', 'border_around_the_chart',
    ]

    const state: {
        isChangeStateLoading: boolean,
        set: TableState,
        message: ApiMessage | undefined,
        appTheme: string, isDarkModeEnabled: boolean,
        treasury: any,

        organization: any

    } = useAppSelector((state) => {
        return {
            isChangeStateLoading: state.treasuryChartPage.isChangeStateLoading,
            set: state.treasuryChartPage.set,
            message: state.treasuryChartPage.message,
            appTheme: state.settings.appTheme, isDarkModeEnabled: state.settings.isDarkModeEnabled,
            treasury: state.treasuryChartPage.treasury,
            organization: state.masterLayout.currentOrganization

        }
    })


    const defaultProps: Omit<ChartContainerProps, 'container'> = {
        symbol: 'USDLYD',
        interval: 'D' as ResolutionString,
        datafeedUrl: 'https://localhost:7166/api/trading-view/udf',
        libraryPath: '/charting_library/',
        chartsStorageUrl: 'https://saveload.tradingview.com',
        chartsStorageApiVersion: '1.1',
        clientId: 'tradingview.com',
        userId: 'public_user_id',
        fullscreen: false,
        autosize: true,
        studiesOverrides: {},
    };


    const DataFeed: IBasicDataFeed = {

        onReady: (callback: any) => {
            setTimeout(() => callback({
                // Represents the resolutions for bars supported by your datafeed
                supported_resolutions: ["60", "1D", "1M", "1Y"],


                supports_search: true,
                supports_group_request: false,
                supports_marks: true,
                supports_timescale_marks: true,
                supports_time: true,

            }));
        },

        searchSymbols: async (
            userInput: any,
            exchange: any,
            symbolType: any,
            onResultReadyCallback: any,
        ) => {


            let resulte: any[] = [];
            if (state.treasury.deposits.length > 0) {
                state.treasury.deposits.forEach((e: any) => {

                    resulte.push({
                        symbol: e.currencyCode,
                        full_name: (e?.currencyName ?? ""), // e.g. BTCE:BTCUSD
                        description: e?.currencyName ?? "",
                        exchange: state.treasury?.name,
                        ticker: e?.currencyId,
                        type: e?.currencySymbol

                    });

                })
            }

            setTimeout(() => { onResultReadyCallback(resulte); }, 0);


        },
        resolveSymbol: async (
            symbolName: any,
            onSymbolResolvedCallback: any,
            onResolveErrorCallback: any,
            extension: any
        ) => {

            if (state.treasury.deposits.length > 0) {
                const found = state.treasury.deposits.find((element: any) => (element.currencyId == symbolName));
                if (found != undefined) {

                    const symbolInfo = {
                        ticker: symbolName,
                        name: (found.currencyName),
                        description: found?.currencyName,
                        type: found.currencySymbol
                        ,
                        session: '24x7',
                        exchange: state.treasury?.name,
                        minmov: 1,
                        logo_urls: ["" + found.iconSource],
                        pricescale: Number("1".padEnd(found.currencyDecimalPlaces, '0')),
                        has_intraday: true,
                        has_daily: true,
                        has_weekly_and_monthly: true,
                        visible_plots_set: 'ohlcv',
                        has_empty_bars: false,
                        supported_resolutions: ["60", "1D", "1M", "1Y"],
                        timezone: "LocalTimeZone" as TimezoneId,

                        // supported_resolutions: ["1S", "1", "15", "30", "60", "240", "1D", "1W"],
                        volume_precision: found.currencyDecimalPlaces,
                        data_status: 'streaming',
                        delay: 0,
                        exchange_logo: state.organization?.logo?.Name ? ORGANIZATION_LOGO_URL + state.organization?.logo?.Name : undefined,
                    };
                    setTimeout(() => { onSymbolResolvedCallback(symbolInfo); }, 0);
                } else {

                    setTimeout(() => { onResolveErrorCallback(); }, 0);
                }
            } else {

                setTimeout(() => { onResolveErrorCallback(); }, 0);

            }





        },

        getBars: async (symbolInfo: any, resolution: any, periodParams: any, onHistoryCallback: any, onErrorCallback: any) => {

            try {

                let from = new Date(periodParams.from * 1000);
                let to = new Date(periodParams.to * 1000);

                const wrapper = new Timestamp();
                wrapper.fromDate(from)
                req.setFrom(wrapper)

                const wrapper2 = new Timestamp();
                wrapper2.fromDate(to)
                req.setTo(wrapper2)
                //   options={[{ key: 3, text: t("hourly") }, { key: 0, text: t("daily") }, { key: 1, text: t("monthly") }, { key: 2, text: t("yearly") },]}

                var groupby = -1;
                if (resolution == "60") {
                    groupby = 3;
                }
                else if (resolution == "1D") {
                    groupby = 0;

                }
                else if (resolution == "1M") {
                    groupby = 1;

                }
                else if (resolution == "12M") {
                    groupby = 2;

                }
                else if (resolution == "1") {
                    groupby = 4;
                } else if (resolution == "15") {
                    groupby = 15;
                } else if (resolution == "30") {
                    groupby = 30;
                } else if (resolution == "240") {
                    groupby = 240;
                } else if (resolution == "10080") {
                    groupby = 10080;
                }
                if (groupby != -1) {

                    req.setGroupby(groupby)
                } else {
                    req.setGroupby(0)
                }

                if (symbolInfo.ticker) {
                    req.setCurrency(symbolInfo.ticker);
                } else {
                    onHistoryCallback([], {
                        noData: true,
                    });
                    return;
                }

                var request = await dispatch(getItems({ body: req, headers: getHeaders() }))
                const payload = request.payload as APIResponse<GetTreasuryBalanceReportResponse.AsObject>;

                var bars = (payload?.response?.success?.reportList.map(val => {

                    let r = {
                        open: Number(val.openningbalance?.value).valueOf(),
                        high: Number(0).valueOf(),
                        low: Number(0).valueOf(),
                        close: Number(val.closingbalance?.value).valueOf(),
                        time: (timestampToDate(val.date?.seconds, val.date?.nanos, groupby >= 3 && groupby <= 240))?.getTime(),
                        volume: (Number(val.totalcredit?.value) + Number(val.totaldebit?.value)).valueOf(),

                    }
                    if (r.open <= r.close) {

                        r.high = r.close
                        r.low = r.open
                    } else {
                        r.high = r.open
                        r.low = r.close
                    }

                    return r;


                }
                ) as any[])

                if (periodParams.firstDataRequest) {
                    lastTime = undefined
                }
                if (bars == undefined || bars.length == 0) {

                    if (periodParams.firstDataRequest) {
                        var yesterday = new Date();
                        var nextTime = moment(yesterday).startOf('day').toDate().getTime() - 1000 * 60 * 60 * 24 * 1;   // current date's milliseconds - 1,000 ms * 60 s * 60 mins * 24 hrs * (# of days beyond one to go back)
                        onHistoryCallback([], {
                            noData: true,
                            nextTime: nextTime
                        });
                    } else {
                        var nextTime = moment(lastTime).startOf('day').toDate().getTime() - 1000 * 60 * 60 * 24 * 1;   // current date's milliseconds - 1,000 ms * 60 s * 60 mins * 24 hrs * (# of days beyond one to go back)
                        onHistoryCallback([], {
                            noData: true,
                            nextTime: nextTime
                        });
                    }

                } else {
                    if (lastTime == undefined) {
                        lastTime = bars[bars.length - 1].time;

                    } else {
                        if (lastTime < bars[bars.length - 1].time) {
                            lastTime = bars[bars.length - 1].time;
                        }
                    }
                    onHistoryCallback(bars, {
                        noData: false,
                    });
                }




            } catch (err) {

                //let message = toApiMessage((err as RpcError).metadata);
                onErrorCallback(err);

            }

        },


        subscribeBars(symbolInfo, resolution, onTick, listenerGuid, onResetCacheNeededCallback) {
            if (myInterval != undefined) {
                clearInterval(myInterval);
            }
            myInterval = setInterval(async () => {
                try {
                    if (lastTime) {



                        let from = new Date(lastTime);
                        const wrapper = new Timestamp();
                        wrapper.fromDate(moment(from, 'YYYY-MM-DD').startOf('day').toDate())
                        req.setFrom(wrapper)


                        let to = new Date();
                        const wrapper2 = new Timestamp();
                        wrapper2.fromDate(moment(to, 'YYYY-MM-DD').endOf('day').toDate())
                        req.setTo(wrapper2)



                        var groupby = -1;
                        if (resolution == "60") {
                            groupby = 3;
                        }
                        else if (resolution == "1D") {
                            groupby = 0;

                        }
                        else if (resolution == "1M") {
                            groupby = 1;

                        }
                        else if (resolution == "12M") {
                            groupby = 2;

                        }
                        else if (resolution == "1") {
                            groupby = 4;
                        } else if (resolution == "15") {
                            groupby = 15;
                        } else if (resolution == "30") {
                            groupby = 30;
                        } else if (resolution == "240") {
                            groupby = 240;
                        } else if (resolution == "10080") {
                            groupby = 10080;
                        }

                        if (groupby != -1) {

                            req.setGroupby(groupby)
                        } else {

                        }

                        if (symbolInfo.ticker) {
                            req.setCurrency(symbolInfo.ticker);
                        } else {
                            return;
                        }
                        var request = await dispatch(getItems({ body: req, headers: getHeaders() }))
                        const payload = request.payload as APIResponse<GetTreasuryBalanceReportResponse.AsObject>;

                        var bars = (payload?.response?.success?.reportList.map(val => {

                            let r = {

                                open: Number(val.openningbalance?.value).valueOf(),
                                high: Number(0).valueOf(),
                                low: Number(0).valueOf(),
                                close: Number(val.closingbalance?.value).valueOf(),
                                time: (timestampToDate(val.date?.seconds, val.date?.nanos, groupby >= 3 && groupby <= 240))?.getTime(),
                                volume: (Number(val.totalcredit?.value) + Number(val.totaldebit?.value)).valueOf(),

                            }
                            if (r.open <= r.close) {

                                r.high = r.close
                                r.low = r.open
                            } else {
                                r.high = r.open
                                r.low = r.close
                            }


                            return r;


                        }
                        ) as any[])



                        if (bars.length != 0) {
                            if (lastTime < bars[bars.length - 1].time) {
                                lastTime = bars[bars.length - 1].time;

                            }

                            onTick(bars[bars.length - 1]);
                        } else {
                        }

                        // onTick(bars[bars.length - 1]);
                    }
                } catch (err) {

                    //throw err
                    //let message = toApiMessage((err as RpcError).metadata);


                }


            }, 60 * 1000);
        },
        unsubscribeBars(listenerGuid) {

        },
    };

    const widgetOptions: ChartingLibraryWidgetOptions = {

        // BEWARE: no trailing slash is expected in feed URL
        // tslint:disable-next-line:no-any
        //datafeed: new (window as any).Datafeeds.UDFCompatibleDatafeed(defaultProps.datafeedUrl),
        datafeed: DataFeed,
        interval: defaultProps.interval as ChartingLibraryWidgetOptions['interval'],
        container: chartContainerRef.current as HTMLDivElement,

        library_path: defaultProps.libraryPath as string,
        locale: getCurrentLanguage() as LanguageCode,
        charts_storage_url: defaultProps.chartsStorageUrl,
        charts_storage_api_version: defaultProps.chartsStorageApiVersion,
        client_id: defaultProps.clientId,
        user_id: defaultProps.userId,
        fullscreen: defaultProps.fullscreen,
        autosize: defaultProps.autosize,
        studies_overrides: defaultProps.studiesOverrides,
        enabled_features: ["study_templates", "move_logo_to_main_pane", "show_symbol_logos", "show_symbol_logo_in_legend",
            "show_zoom_and_move_buttons_on_touch", "show_exchange_logos", "saveload_separate_drawings_storage", "disable_resolution_rebuild"] as ChartingLibraryFeatureset[],
        disabled_features: isMobile ? disabled_features_mobile : disabled_features,
        theme: state?.isDarkModeEnabled ? "dark" : 'light',
        debug: false,
        save_load_adapter: new LocalStorageSaveLoadAdapter(),
        timezone: "LocalTimeZone" as TimezoneId,
        custom_timezones: [
            {
                id: 'LocalTimeZone' as CustomTimezoneId,
                title: 'Local Time Zone',
                alias: `Etc/GMT${(new Date().getTimezoneOffset() / -60) >= 0 ? '-' : '+'}${Math.abs(new Date().getTimezoneOffset() / -60)}`
            },
        ],
    };


    useEffect(() => {
        req = new GetTreasuryBalanceReportRequest();
        reqAcc = new GetTreasuryRequest();

        var l = searchParams.get('org');

        if (l) {
            org = Number(l);
            if (Number.isNaN(org)) {
                org = -1;
            } else {
                const wrapper = new Int32Value();
                wrapper.setValue(org);

            }
        }
        if (!props.isSelection) {
            const page = getPage(key)
            dispatch(setTitle(t(normalizeKey(page?.title))));
            dispatch(setPage(page));
        }
        var symbol = searchParams.get('symbol');
        if (symbol == null) {
            navigate(-1)
            return;
        }
        reqAcc.setId(symbol)
        req.setTreasury(symbol)
        getItemsPromise = dispatch(getTreasury({ body: reqAcc, headers: getHeaders() }))


        return () => {
            // tvWidget.remove();
            getItemsPromise?.abort();
            getFilterPromise?.abort();
            actionPromise?.abort();
            dispatch(reset());
            clearInterval(myInterval);

        };
    }, []);



    useEffect(() => {
        if (state.treasury) {
            //console.log(state.treasury.deposits?.at(0)?.currencyId)
            widgetOptions.symbol = state.treasury.deposits?.at(0)?.currencyId;
            initWedgit();
        }
    }, [state.treasury])
    const initWedgit = () => {

        const tvWidget = new widget(widgetOptions);
        tvWidget?.chartReady().then(() => {
            tvWidget.activeChart().setChartType(2);


        });



    }
    return (
        <div ref={chartContainerRef}
            className={'TVChartContainer'}
            style={{ height: props.isSelection ? "60vh" : state.message == undefined ? "calc(100vh - 100px)" : "calc(100vh - 148px)" }}>
            {state.message != undefined ? (state.message.data != 401) ? <Message
                body={state.message.body}
                title={state.message.title}
                data={state.message.data}
                onDismiss={() => { dispatch(dismissMessage()) }}
                type={state.message.type}
            /> :
                <SessionExpiredDialog />
                : null
            }

        </div>

    );
}




